import { Playbook } from "../types/playbook/playbook";

export const GetPlaybookPlayCount = (playbook: Playbook) => {
  let playCount = 0;

  playbook.chapters.forEach((chapter) => {
    chapter.sections.forEach((section) => {
      playCount += section.plays.length;
    });
  });

  return playCount;
};
